import { clone } from 'lodash';
import {
  DESELECT_ALL_ACCOUNTS,
  SET_ACCOUNTS_TYPE,
  SET_CUSTOMERS_TYPE,
  SET_MANAGED_ACCOUNT_EMAIL_TYPE,
  SET_MANAGED_CUSTOMER_ID_TYPE,
  TOGGLE_CHECKED_ACCOUNTS,
  TOGGLE_SELECT_ALL_ACCOUNTS,
} from './actions';

const defaultState = {
  accounts: [],
  customers: [],
  managedAccountEmail: null,
  managedCustomerId: null,
  checkedAccounts: [],
};

const SSOAccountsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_ACCOUNTS_TYPE: {
      return { ...state, accounts: action.payload };
    }

    case SET_MANAGED_ACCOUNT_EMAIL_TYPE: {
      return { ...state, managedAccountEmail: action.payload };
    }

    case SET_MANAGED_CUSTOMER_ID_TYPE: {
      return { ...state, managedCustomerId: action.payload };
    }

    case SET_CUSTOMERS_TYPE: {
      return { ...state, customers: action.payload };
    }

    case TOGGLE_SELECT_ALL_ACCOUNTS: {
      let checkedAccountsII;
      // Check if all accounts on current page is checked
      const allSelected = state.checkedAccounts
        .filter((checked) => (state.accounts.filter((acc) => (checked.email === acc.email)).length > 0))
        .length === state.accounts.length;

      if (allSelected) {
        // Filter checked accounts to exclude accounts from current page
        checkedAccountsII = state.checkedAccounts
          .filter((checked) => (state.accounts.filter((acc) => (acc.email === checked.email)).length === 0));
      } else {
        // Find accounts which is not selected yet
        const notSelected = state
          .accounts
          .filter((acc) => (state.checkedAccounts.filter((checked) => (checked.email === acc.email)).length === 0));

        // And add them to checked array
        checkedAccountsII = [...state.checkedAccounts, ...notSelected];
      }

      return { ...state, checkedAccounts: checkedAccountsII };
    }

    case DESELECT_ALL_ACCOUNTS:
      return { ...state, checkedAccounts: [] };

    case TOGGLE_CHECKED_ACCOUNTS: {
      const isChecked = state.checkedAccounts.filter((checked) => (checked.email === action.account.email)).length > 0;
      const checkedAccounts = isChecked
        ? state.checkedAccounts.filter((account) => (account.email !== action.account.email))
        : [...state.checkedAccounts, clone(action.account)]; // _clone is needed to avoid changing original store accounts

      return { ...state, checkedAccounts };
    }

    default:
      return state;
  }
};

export default SSOAccountsReducer;
